import { Team } from "@brg/api";
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { getOrganizationRepostOptions, MAIN_FILTER_REPOST_PATH } from "./repostProjectIds";

export const normalizedTab = (
    team: Team<'Global'>,
    moderationType: ModerationType,
    language: string,
) => getOrganizationRepostOptions(team, moderationType, language);

export const generateTabFilter = (team: Team<'Global'>, tabId: string, language: string) => {
    if (!tabId || tabId === MAIN_FILTER_REPOST_PATH) {
        return {
            ...team?.mainFilter,
            name: team?.name,
            path: MAIN_FILTER_REPOST_PATH,
        };
    }

    return team?.tabs?.find((tab) => tab.path === tabId);
};

export { MAIN_FILTER_REPOST_PATH };
import { Team } from "@brg/api";
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { getOrganizationRepostOptions, MAIN_FILTER_REPOST_PATH } from "./repostProjectIds";

export const normalizedTab = (
    team: Team<'Global'>,
    moderationType: ModerationType,
    language: string,
) => getOrganizationRepostOptions(team, moderationType, language);

export const generateTabFilter = (team: Team<'Global'>, tabId: string, language: string) => {
    if (!tabId || tabId === MAIN_FILTER_REPOST_PATH) {
        return {
            ...team?.mainFilter,
            name: team?.name,
            path: MAIN_FILTER_REPOST_PATH,
        };
    }

    return team?.tabs?.find((tab) => tab.path === tabId);
};

export { MAIN_FILTER_REPOST_PATH };
